import SvgIcon from '../index';
const req = require.context('@/assets/icons', false, /\.svg$/);
const requireAll = (requireContext) => requireContext.keys().map(requireContext);
requireAll(req);

const SvgIconPlugin = {
  install(Vue) {
    Vue.component('svg-icon', SvgIcon);
  }
};

export default SvgIconPlugin;
